import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/no-img.bb9c4fe3.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f5efb772"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "newMusic"
};
var _hoisted_2 = {
  key: 0,
  class: "newMusic-box"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "index"
};
var _hoisted_5 = {
  class: "iconfont icon-icon_horn index"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_7 = {
  class: "songer linelittle"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "slash"
  }, "/", -1
  /* HOISTED */
  );
});

var _hoisted_9 = {
  class: "album"
};
var _hoisted_10 = {
  class: "time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _component_Loading = _resolveComponent("Loading");

  var _directive_minTenIndex = _resolveDirective("minTenIndex");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.newMusicList.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newMusicList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "music-item",
      key: index,
      onClick: function onClick($event) {
        return _ctx.itemClick(item.id);
      }
    }, [_createCommentVNode(" 索引 "), _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [_createTextVNode(_toDisplayString(index + 1), 1
    /* TEXT */
    )])), [[_directive_minTenIndex], [_vShow, _ctx.currentId !== item.id]]), _createCommentVNode(" 图标 "), _withDirectives(_createElementVNode("i", _hoisted_5, null, 512
    /* NEED_PATCH */
    ), [[_vShow, _ctx.currentId == item.id]]), _createCommentVNode(" 图片 "), _createVNode(_component_el_image, {
      src: item.album.blurPicUrl
    }, {
      placeholder: _withCtx(function () {
        return [_hoisted_6];
      }),
      _: 2
      /* DYNAMIC */

    }, 1032
    /* PROPS, DYNAMIC_SLOTS */
    , ["src"]), _createCommentVNode(" 音乐名 "), _createElementVNode("div", {
      class: _normalizeClass(['text', _ctx.currentId == item.id && 'active'])
    }, _toDisplayString(item.name), 3
    /* TEXT, CLASS */
    ), _createCommentVNode(" 歌手 "), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.artists, function (songer) {
      return _openBlock(), _createElementBlock("span", {
        class: "songer-item",
        key: songer.id
      }, [_createElementVNode("span", null, _toDisplayString(songer.name), 1
      /* TEXT */
      ), _hoisted_8]);
    }), 128
    /* KEYED_FRAGMENT */
    ))]), _createCommentVNode(" 专辑 "), _createElementVNode("div", _hoisted_9, _toDisplayString(item.album.name), 1
    /* TEXT */
    ), _createCommentVNode(" 时间 "), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$filters.formatTime(item.bMusic.playTime, "mm:ss")), 1
    /* TEXT */
    )], 8
    /* PROPS */
    , _hoisted_3);
  }), 128
  /* KEYED_FRAGMENT */
  ))])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1
  }))]);
}